// Generated by ts-to-zod
import { z } from 'zod';
import { hookTypeSchema } from './hook.schema';
import {
  annotationContentActionSchema,
  annotationStatusActionSchema,
  emailActionSchema,
  invocationActionSchema,
  uploadActionSchema,
} from './hookUtils.schema';
import { logLevelSchema } from './runLog.schema';

export const statusCodeSchema = z.union([
  z.literal('200'),
  z.literal('201'),
  z.literal('202'),
  z.literal('203'),
  z.literal('204'),
  z.literal('205'),
  z.literal('206'),
  z.literal('207'),
  z.literal('208'),
  z.literal('226'),
  z.literal('400'),
  z.literal('401'),
  z.literal('402'),
  z.literal('403'),
  z.literal('404'),
  z.literal('405'),
  z.literal('406'),
  z.literal('407'),
  z.literal('408'),
  z.literal('409'),
  z.literal('410'),
  z.literal('411'),
  z.literal('412'),
  z.literal('413'),
  z.literal('414'),
  z.literal('415'),
  z.literal('416'),
  z.literal('417'),
  z.literal('418'),
  z.literal('421'),
  z.literal('422'),
  z.literal('423'),
  z.literal('424'),
  z.literal('425'),
  z.literal('426'),
  z.literal('428'),
  z.literal('429'),
  z.literal('431'),
  z.literal('451'),
  z.literal('500'),
  z.literal('501'),
  z.literal('502'),
  z.literal('503'),
  z.literal('504'),
  z.literal('505'),
  z.literal('506'),
  z.literal('507'),
  z.literal('508'),
  z.literal('510'),
  z.literal('511'),
]);

export const runStatusSchema = z.union([
  z.literal('completed'),
  z.literal('failed'),
  z.literal('running'),
  z.literal('cancelled'),
  z.literal('waiting'),
]);

const runBaseSchema = z.object({
  hookId: z.number(),
  hookType: hookTypeSchema,
  logLevel: logLevelSchema,
  message: z.string(),
  queueId: z.number().optional().nullable(),
  request: z.string().nullable(),
  requestId: z.string(),
  response: z.string().nullable(),
  timestamp: z.string(),
  start: z.string().optional(),
  end: z.string().optional(),
  status: runStatusSchema.optional(),
  settings: z.unknown().optional(),
  uuid: z.string().optional(),
});

const annotationContentRunSchema = runBaseSchema.and(
  z.object({
    annotationId: z.number().optional().nullable(),
    event: z.literal('annotation_content'),
    action: annotationContentActionSchema,
  })
);

const annotationStatusRunSchema = runBaseSchema.and(
  z.object({
    annotationId: z.number().optional().nullable(),
    event: z.literal('annotation_status'),
    action: annotationStatusActionSchema,
  })
);

const uploadRunSchema = runBaseSchema.and(
  z.object({
    emailId: z.number().optional().nullable(),
    event: z.literal('upload'),
    action: uploadActionSchema,
  })
);

const emailRunSchema = runBaseSchema.and(
  z.object({
    emailId: z.number().optional().nullable(),
    event: z.literal('email'),
    action: emailActionSchema,
  })
);

const invocationRunSchema = runBaseSchema.and(
  z.object({
    event: z.literal('invocation'),
    action: invocationActionSchema,
  })
);

export const runSchema = z.union([
  annotationContentRunSchema,
  annotationStatusRunSchema,
  uploadRunSchema,
  emailRunSchema,
  invocationRunSchema,
]);
